import { getCookie } from './cookies';

const fireMonetizationDetailEvent = () => {
  if (typeof window !== 'undefined') {
    const delayFiring = 3000;
    setTimeout(() => {
      const dataLayer = window.dataLayer || [];
      const adVisible = getCookie('adRendered');
      const adImplemented =
        window._dfpObj && typeof window._dfpObj === 'object';
      const isPrime = window.App.state?.isPrime;
      const isTaboolaImplemented =
        window.TRC && typeof window.TRC?._taboolaClone === 'object';
      // #todo ::  need to revisit the logic for new Gam
      const adCode =
        window.Times &&
        Array.isArray(window.Times.pageLoadAdsArr) &&
        window.Times.pageLoadAdsArr[1]
          ? window.Times.pageLoadAdsArr[1].adCode
          : '';
      const gamType = adCode.indexOf('23037861279') !== -1 ? 'new' : 'old';
      let adNotVisibleReason;

      if (!adImplemented && isPrime) {
        adNotVisibleReason = 'prime_user';
      } else if (adImplemented && adVisible === '0') {
        adNotVisibleReason = 'ad_blocker';
      } else if (adImplemented && adVisible === '1') {
        adNotVisibleReason = 'N/A';
      } else {
        adNotVisibleReason = 'not_identified';
      }

      const params = {
        event: 'monetization_detail',
        ad_implemented: adImplemented ? 'yes' : 'no',
        ad_visible: adVisible === '1' && !isPrime ? 'yes' : 'no',
        ad_not_visible_reason: adNotVisibleReason,
        taboola_implemented: isTaboolaImplemented ? 'yes' : 'no',
        gam_type: adImplemented ? gamType : 'N/A',
      };
      dataLayer.push(params);
    }, delayFiring);
  }
};

export default fireMonetizationDetailEvent;
